import { render } from "./CompassComponent.vue?vue&type=template&id=4e47befe"
import script from "./CompassComponent.vue?vue&type=script&lang=js"
export * from "./CompassComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__